import { createContext } from 'react'

export const ServerContext = createContext<string>('http://oxxo.ddns.net/api');